import { createQueryParams } from '../../utils/Function/commonFunction';
import axiosBasicInstance from '../axiosConfig';
import { startOfMonth, endOfMonth } from "date-fns";

const buildFromToUTC = (month, year) => {
   const start = new Date(Date.UTC(year, month - 1, 1, 0, 0, 0));
   const end = new Date(Date.UTC(year, month, 0, 23, 59, 59));

   return {
      from: start.toISOString(),
      to: end.toISOString(),
   };
};

const buildFromToUTCByDate = (date) => {
   const d = new Date(date);

   const start = new Date(Date.UTC(
      d.getUTCFullYear(),
      d.getUTCMonth(),
      d.getUTCDate(),
      0, 0, 0
   ));

   const end = new Date(Date.UTC(
      d.getUTCFullYear(),
      d.getUTCMonth(),
      d.getUTCDate(),
      23, 59, 59
   ));

   return {
      from: start.toISOString(),
      to: end.toISOString(),
   };
};



// const getEventList = async (page, record, selectedDate, userId, shiftId, errorLog = false, langId, groupId) => {
//    try {
//       const response = await axiosBasicInstance.get(`/management/event?${createQueryParams({ page, record })}`, {
//          headers: { 
//             'x-selectDate': selectedDate, 
//             'x-userId': userId, 
//             'x-shiftId': shiftId, 
//             errorLog: String(errorLog),
//             'x-language': langId,
//             'x-groupId': groupId
//          },
//       });
//       return response;
//    } catch (error) {
//       throw error;
//    }
// };

const getEventList = async (
  page,
  record,
  from,          // ✅ nhận trực tiếp
  to,            // ✅ nhận trực tiếp
  userId,
  shiftId,
  errorLog = false,
  enableLog = true,
  langId,
  groupId
) => {
  return axiosBasicInstance.get(
    "/management/event",
    {
      params: {
        page,
        record,
        from,
        to,
        isError: errorLog,
        isEnabled: enableLog,
      },
      headers: {
        userId,
        shiftId,
        groupId,
        "x-language": langId,
      },
    }
  );
};

const getEventListCheckOut = async (
  page,
  record,
  from,          // ✅ nhận trực tiếp
  to,            // ✅ nhận trực tiếp
  userId,
  shiftId,
  errorLog = false,
  enableLog = true,
  langId,
  groupId
) => {
  return axiosBasicInstance.get(
    "/management/event/checkout",
    {
      params: {
        page,
        record,
        from,
        to,
        isError: errorLog,
        isEnabled: enableLog,
      },
      headers: {
        userId,
        shiftId,
        groupId,
        "x-language": langId,
      },
    }
  );
};

const getEventListCheckIn = async (
  page,
  record,
  from,          // ✅ nhận trực tiếp
  to,            // ✅ nhận trực tiếp
  userId,
  shiftId,
  errorLog = false,
  enableLog = true,
  langId,
  groupId
) => {
  return axiosBasicInstance.get(
    "/management/event/checkin",
    {
      params: {
        page,
        record,
        from,
        to,
        isError: errorLog,
        isEnabled: enableLog,
      },
      headers: {
        userId,
        shiftId,
        groupId,
        "x-language": langId,
      },
    }
  );
};


const getEventDashboard = async (langId) => {
   try {
      // Dashboard aggregate chậm khi mạng yếu — tránh timeout 30s mặc định làm chart trống dù server đã trả data
      const response = await axiosBasicInstance.get(`/management/event/dashboard`, {
         headers: {
            langId
         },
         timeout: 60000,
      });
      return response;
   } catch (error) {
      throw error;
   }
};

const getCalendarEvents = async (
   from,
   to,
   langId,
   userId = "",
   groupId = "",
   accountId = ""
) => {
   return axiosBasicInstance.get(
      "/management/event/calendars",
      {
         params: {
            from,
            to,
            isError: false,
            userId,
            groupId,
            accountId,
         },
         headers: { langId },
      }
   );
};

const createAttendance = async (id, langId, timeZone) => {
   try {
      const response = await axiosBasicInstance.post(
         `/management/event/attendance/${id}/${langId}`,
         null,
         {
            headers: {
               timeZone: timeZone
            }
         }
      );
      return response;
   } catch (error) {
      throw error;
   }
};

const allowAttendance = async (id, langId) => {
   try {
      const response = await axiosBasicInstance.get(`/management/event/attendance/${id}`, {
         headers: {
            langId
         },
      });
      return response;
   } catch (error) {
      throw error;
   }
};

const deleteAttendance = async (id, langId) => {
   try {
      const response = await axiosBasicInstance.delete(`/management/event/attendance/${id}`, {
         headers: {
            langId
         },
      });
      return response;
   } catch (error) {
      throw error;
   }
};

const deleteRequestAttendance = async (id, langId) => {
   try {
      const response = await axiosBasicInstance.delete(`/management/event/request-attendance/${id}`, {
         headers: {
            langId
         },
      });
      return response;
   } catch (error) {
      throw error;
   }
};

const addEventLog = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/addEventLog', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const editEventLog = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/editEventLog', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const deleteEventLog = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/deleteEventLog', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getListRequestType = async (langId) => {
   try {
      const response = await axiosBasicInstance.get('/management/event/getListRequestType', {
         headers: {
            langId
         },
      });
      return response;
   } catch (error) {
      throw error;
   }
};

const AddRequest = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/addRequest', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getRequestList = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/getRequestList', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getPendingRequestList = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/getPendingRequestList', data);
      return response;
   } catch (error) {
      throw error;
   }
};


const getRequestSwapList = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/getRequestSwapList', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const requestCalendar = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/requestCalendar', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const requestById = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/request/detail', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const requestSwapById = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/request/swap/detail', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const imgEventCalendar = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/img-event-calendar', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const editEventlogRequest = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/editEventlogRequest', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const editRequest = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/editRequest', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const rejectRequest = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/reject', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const approveRequest = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/approve', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const deleteRequest = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/deleteRequest', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getHistoryRequest = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/getHistoryRequest', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getImgEvent = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/getImgEvent', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getEventsRecent = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/eventsRecent', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const addEventLogBulk = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/addEventLogBulk', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const changeStatusSwap = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/change-status-swap', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const swapCalendar = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/swap-calendar', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const swapChart = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/swap-chart', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const exportEventLogCSV = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/event/exportEventLogCSV', data, {
         responseType: 'blob'
      });
      return response;
   } catch (error) {
      throw error;
   }
};

export {
   allowAttendance, createAttendance, deleteAttendance, getEventDashboard, imgEventCalendar, getEventsRecent,
   getEventList, addEventLog, editEventLog, deleteEventLog, getListRequestType, AddRequest,
   getRequestList, requestCalendar, editEventlogRequest, editRequest, rejectRequest, approveRequest, deleteRequest, getHistoryRequest, getImgEvent, addEventLogBulk,
   requestById, getCalendarEvents, deleteRequestAttendance, changeStatusSwap, swapCalendar, swapChart, getRequestSwapList, requestSwapById, getEventListCheckIn, getEventListCheckOut,
   getPendingRequestList, exportEventLogCSV
};
